
import React from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { CreditCard } from "lucide-react";
import { WaitlistFormValues, fairDealOptions } from "../schema";

interface SectionProps {
  control: Control<WaitlistFormValues>;
}

export function FinancialSection({ control }: SectionProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-grandpal-beige">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <CreditCard className="h-5 w-5 text-grandpal-green" />
        Financial Information
      </h3>
      
      <FormField
        control={control}
        name="fairDealScheme"
        render={({ field }) => (
          <FormItem className="space-y-3 mb-4">
            <FormLabel>Are you planning to use the Fair Deal Scheme?</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                defaultValue={field.value}
                className="flex flex-col space-y-1"
              >
                {fairDealOptions.map((option) => (
                  <FormItem key={option.id} className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value={option.id} />
                    </FormControl>
                    <FormLabel className="font-normal">
                      {option.label}
                    </FormLabel>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormDescription>
              The Nursing Homes Support Scheme (Fair Deal) provides financial support for people who need long-term nursing home care.
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
